/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-14 09:59:19
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2023-05-15 17:03:56
 * @FilePath: \qcloud-web-pc-4.0\src\views\home\lang\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const home = {
  for_teacher: 'Educator',
  for_teacher_desc:
    "You can facilitate students' learning in quantum computing <br /> with the courses and resources provided by Origin Quantum,  <br />thus enabling them to study in the field and build the future.",
  contactUs: 'Contact Us',
  course_title: 'The curriculum system of quantum computing in universities ',
  course_desc:
    'Help colleges and universities set up quantum computing courses by designing curriculum system, providing real work scenes and practical projects to help students understand the courses in both theory and practice. ',
  hardware: 'Quantum computing hardware',
  hardware_desc:
    'Sign up for the Origin Quantum Cloud and visit the real quantum computer.<br />Learning, building and practicing quantum applications in real time through the real quantum computer and classical computing resources.',
  software: 'Education software and tools',
  software_desc:
    'Help cultivate quantum computing talents and provides end-to-end application with software and hardware integration.',
  tr_platform: 'Quantum T&R Platform',
  tr_platform_desc:
    'Quantum teaching software for educational institutions to help schools build their own quantum computing teaching system.  ',
  learn_machine: 'Full-Physical System Quantum Learning Machine',
  learn_machine_desc:
    'One-stop system environment that provides learning, training, development, experiment and application related to quantum computing and quantum algorithm',
  more_next: 'More',
  OriginqName: 'OriginQ Suzhi',
  for_college: '高校专属',
  free: '免费',
  resources: 'Resources ',
  learn_quantum_computer: 'Quantum computer',
  learn_qubit_structure: 'Qubit structure',
  learn_quantum_comput_demon: 'Quantum computing demonstration',
  learn_chip_packaging: 'Chip packaging',
  learn_calculate_title1: 'Full-Physical System Quantum Learning Machine',
  subject_cooperation: 'Subject cooperation',
  learn_calculate_desc1:
    '本源量子计算全物理体系学习机是一个专为量子计算行业学习和从业人员设计的完整的仿真环境，它致力于量子算法及量子软件的学习、培训、开发、实验和应用。',
  'Solu-subject-1': 'Integration of Science, Innovation and Education',
  'Solu-subject-11': '“科创融教”省部级纵向课题',
  'Solu-subject-12':
    '“科创融教”项目是由教育部行指委立项的一批教育改革创新课题，旨在研究解决“十四五规划”建设中教育的重点、难点问题。项目一年开展一次，每年10月份申报新一轮课题项目。<br />2021年，本源量子计算科技（合肥）股份有限公司获教育部行指委授权，为“产教融合研究”、“教学改革与创新创业教育研究”、“信息技术在教学中的应用”三大研究领域的六个研究方向提供技术支持，助力高校在相关领域进行深入研究。<br />首届“科创融教”省部级纵向课题已有50余所高校相继咨询、申报本源量子授权课题。今后，本源将继续本着“携手共进”原则，联合中国科学技术大学量子计算知名专家及本源量子资深行业应用研究员，为各申报院校提供一站式申报服务。',
  'Solu-subject-2': 'Industry-University Cooperation for Talent Cultivation',
  'Solu-subject-21': '"Industry-University Cooperation for Talent Cultivation"',
  'Solu-subject-22':
    '教育部产学合作协同育人项目，是国家为了本科人才培养质量，深化产教融合、校企合作，教育部高等教育司组织有关企业支持高校共同开展产学合作协同育人的项目。<br />《教育部高等教育司2021年工作要点》指出，将深入推进新工科、新医科、新农科、新文科建设，促进“四新”交叉融合，提升国家硬实力、全民健康力、生态成长力和文化影响力。产学合作协同育人项目纳入新一轮普通高等学校本科教育教学审核评估指标体系。<br />本源量子将积极参与教育部高等教育司产学合作协同育人项目，携手各高校在新工科建设方面创新实践，助力高校推进学科建设发展。',
  'Solu-subject-3': '"Beijng Innovation Assistant"',
  'Solu-subject-31': '"Beijng Innovation Assistant"',
  'Solu-subject-32':
    '“北创助教项目(二期)”面向高校的量子计算、人工智能、轨道交通、智慧财务、智能建筑、社会科学、国际化人才培养在教育领域的应用而设立，以科技变革促进教育变革，创新人才培养机制，推动社会发展为目标。<br />2021年，本源量子计算科技（合肥）股份有限公司获北京创新研究所授权，为“量子计算教学内容和课程体系改革”、“量子计算应用研究及条件建设项目”两大课题方向提供技术支持，助力高校在相关领域进行深入研究。',
  competition_resources: 'Competition resources ',
  competition_resources_desc:
    'Provide courses and exercises according to quantum computing programming competition. ',
  discipline_construction: 'Discipline construction resources ',
  discipline_construction_desc:
    'Provide quantum computing teacher training, teaching handouts, courseware and practical training resources. ',
  open_learn: 'Open learning resources ',
  open_learn_desc:
    'Provide QPanda quantum computing programming framework, textbooks and popular science reading resources.',

  platform_title: 'Quantum Computing Cloud Service Platform',
  platform_serve: 'Quantum Computing Serving People',
  platform_text:
    'Origin Quantum Cloud provides real quantum computing, <br />quantum computer simulator and back-end connecting of hybrid quantum supercomputing, <br />including basic software and development tools for developers and application services<br /> for enterprises in biochemistry, fintech, big data and machine learning.',
  gonow: 'Try Now',
  support: 'Here,we are ready to support you.',
  solution: 'Quantum Computing+Industry Solutions',
  trip: 'Quantum on OriginQ，Journey Together',
  app_serve: 'Quantum App Service',
  ChemiQ: 'ChemiQ',
  portfolio_optimization: 'portfolio optimization',
  option_calculator: 'option calculator',
  var_cal: 'quantum VaR value calculation',
  pricing: 'option quantum pricing',
  image_recognition: 'image recognition',
  QCFD: 'QCFD',
  more: 'more',
  cal_serve: 'Quantum Computing Service',
  real_cal: 'Real Quantum Computing Service',
  sim_cal: 'Simulation Quantum Computing Service',
  hybrid: 'Hybrid Quantum Supercomputing Service',
  community: 'Education & Community',
  education: 'Education',
  contest: 'Competition',
  comm: 'Community',
  soft_serve: 'Quantum Software',
  pilot: 'Origin Pilot',
  QPanda: 'QPanda',
  QRunes: 'QRunes',
  VQNet: 'VQNet',
  gui: 'GUI Programming',
  Qurator: 'Qurator',
  Starter: 'Starter',
  starter_desc:
    'You can learn the basic concepts of quantum computing and design your first quantum program with GUI tools by following tutorials.',
  Student: 'Student',
  student_desc:
    'You only need a few minutes every day to acquire practical skills in quantum computing with open source software and relevant tutorials.',
  Developer: 'Developer',
  developer_desc:
    'You can build a quantum virtual research environment on a PC with the open source software or conduct research using quantum hardware on Origin Ouantum Cloud.',
  Educator: 'Educator',
  educator_desc:
    "You can facilitate students' learning in quantum computing with the courses and resources provided by Origin Quantum.",
  Company: 'Company',
  company_desc:
    'We are committed to promoting the application of quantum computing in AI, big data, finance, biomedicine, and other scenarios, and accelerating the actual application process of quantum computing.',
  Industrial_Alliance: 'Industrial Alliance',
  industrial_Alliance_desc:
    'You can work with partners for quantum computing development and application, thus achieving benefits sharing and win-win cooperation.',
  biochemistry: 'Biochemistry',
  biochemistry_desc:
    'Quantum computing empowers and accelerates <br/> biomedicine research.',
  finance: 'Financial Technology',
  finance_desc:
    'Origin Quantum promotes the quantum ecosystem and its coordinated development with the financial industry by focusing on the financial application scenarios.',
  educate: 'Quantum Education',
  educate_desc:
    'In the context of current development of quantum computing education,we provide you with full-scenario solutions based on Origin Quantum\'s full-stack education products.',
  bigData: 'Big Data',
  bigData_desc:
    'Because of the parallel data processing characteristics and the massive information storage space in quantum states, quantum computing is inherently suitable for big data processing.',
  ai: 'AI',
  ai_desc:
    'Quantum computers can analyze data and provide feedback more effectively than traditional computers, thus flattening the learning curve of artificial intelligence machines.',
  learn_lab_detail4: 'Coming Soon',
  serviesTitle: 'Computing Service',
	serviesText: 'Users can run algorithms or perform experimental tasks through the OriginQ Cloud, Wukong series' +
		' superconducting quantum computers and simulator services.',
	serviesTitleOne: 'Real Quantum Computing Services',
	systemStatus: 'System State',
	lineTime: 'Login Time',
	calibrateTime: 'Last Calibration Time',
	quantumBit: 'Qubit',
	simulateServies: 'Simulator Services',
	simulateType: 'Types of simulators ',
	bitName: '-qubit superconducting quantum computer',
	freeText: 'Free',
	ttText1:'Tasks in the queue',
  ttText2:'Latest calibration time',
  ttText3:'Latest calibrated qubits',
  ttText4:'Latest calibrated qubit pairs',
  ttText5:'Qubit',
	block1_text34:'In maintenance',
	chip_record:'history calibration Info',
	chip_name:'Computing Service',
	chip_school_time:'Calibration time',
	chip_school_bit:'Calibration qubits',
	chip_school_pair:'Calibration couplers',
};
export default home;
